import React from 'react';
import { useBoardSelector } from '../../../state';
import { activeSprintsSelector } from '../../../state/selectors/sprint/sprint-selectors.tsx';
import SprintControls from './view';

// Still in progress https://jplat.atlassian.net/browse/BLU-3256
export const SprintPopup = () => {
	const activeSprints = useBoardSelector(activeSprintsSelector); // TODO BLU-4236 clarify if this is the correct selector over getSprintsSelector, what is the difference?

	if (!activeSprints?.length) {
		return null;
	}

	return <SprintControls activeSprints={activeSprints} />;
};
